export default function isCustomComponent(element: React.ReactElement): boolean {
    return typeof element.type !== "string";
}